/* FOCUS · LANDING V2 — comportamientos compartidos.
   Sin librerías: aparición al hacer scroll, FAQ, comparativa y opiniones. */
(function () {
  'use strict';

  // Cada sección de la V2 incluye este guion (así sobrevive a que se quite o
  // se reordene una sección en el editor). El navegador lo descarga una sola
  // vez, pero EJECUTA una vez por etiqueta <script>: sin este cerrojo los
  // escuchadores se duplicarían y el FAQ se abriría y cerraría solo.
  if (window.__fev2Iniciado) return;
  window.__fev2Iniciado = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Los bloques son visibles en CSS desde el primer fotograma. No hay nada
  // que esperar: este paso solo marca la clase por si alguna hoja vieja
  // todavía la usa.
  function initReveal() {
    var els = document.querySelectorAll('.v2-reveal');
    Array.prototype.forEach.call(els, function (el) { el.classList.add('v2-visible'); });
  }

  // FAQ: acordeón accesible con altura animada.
  function initFaq() {
    var items = document.querySelectorAll('.v2-faq__item');
    if (!items.length) return;
    Array.prototype.forEach.call(items, function (item) {
      var btn = item.querySelector('.v2-faq__pregunta');
      var res = item.querySelector('.v2-faq__respuesta');
      if (!btn || !res) return;
      btn.addEventListener('click', function () {
        var abierto = item.classList.contains('v2-abierto');
        item.classList.toggle('v2-abierto', !abierto);
        btn.setAttribute('aria-expanded', abierto ? 'false' : 'true');
        res.style.maxHeight = abierto ? null : res.scrollHeight + 'px';
      });
    });
    // Si cambia el ancho, la altura calculada deja de valer.
    window.addEventListener('resize', function () {
      Array.prototype.forEach.call(document.querySelectorAll('.v2-faq__item.v2-abierto'), function (item) {
        var res = item.querySelector('.v2-faq__respuesta');
        if (res) res.style.maxHeight = res.scrollHeight + 'px';
      });
    });
  }

  // Comparativa: en móvil se enseñan solo las filas fuertes.
  function initComparativa() {
    var botones = document.querySelectorAll('[data-v2-cmp-mas]');
    Array.prototype.forEach.call(botones, function (btn) {
      var tabla = document.getElementById(btn.getAttribute('data-v2-cmp-mas'));
      if (!tabla) return;
      btn.addEventListener('click', function () {
        var abierta = tabla.classList.toggle('v2-cmp--abierta');
        btn.textContent = abierta
          ? btn.getAttribute('data-menos') || 'Ver menos'
          : btn.getAttribute('data-mas') || 'Ver la comparativa completa';
      });
    });
  }

  // Opiniones: páginas numeradas (las fotos de páginas 2+ se calientan en idle).
  function initOpiniones() {
    var navs = document.querySelectorAll('[data-v2-op-nav]');
    Array.prototype.forEach.call(navs, function (nav) {
      var grid = document.getElementById(nav.getAttribute('data-v2-op-grid'));
      if (!grid) return;
      var tarjetas = Array.prototype.slice.call(grid.querySelectorAll('[data-v2-op-pagina]'));
      function calentarFotos() {
        tarjetas.forEach(function (t) {
          var img = t.querySelector('.v2-op__foto, .v2-op__foto-grande');
          if (!img || !img.getAttribute('src')) return;
          img.loading = 'eager';
          if (!img.complete) { new Image().src = img.src; }
        });
      }
      if ('requestIdleCallback' in window) {
        requestIdleCallback(calentarFotos, { timeout: 3000 });
      } else {
        setTimeout(calentarFotos, 1200);
      }
      var numeros = Array.prototype.slice.call(nav.querySelectorAll('[data-v2-op-ir]:not([data-v2-op-ir="anterior"]):not([data-v2-op-ir="siguiente"])'));
      var anterior = nav.querySelector('[data-v2-op-ir="anterior"]');
      var siguiente = nav.querySelector('[data-v2-op-ir="siguiente"]');
      var total = numeros.length;
      var actual = 1;

      function pintar(pagina, saltar) {
        actual = Math.min(Math.max(pagina, 1), total);
        tarjetas.forEach(function (t) {
          var suya = parseInt(t.getAttribute('data-v2-op-pagina'), 10) === actual;
          t.classList.toggle('v2-op--pagina-oculta', !suya);
        });
        numeros.forEach(function (b) {
          var activa = parseInt(b.getAttribute('data-v2-op-ir'), 10) === actual;
          b.classList.toggle('v2-op__pagina--activa', activa);
          if (activa) { b.setAttribute('aria-current', 'true'); } else { b.removeAttribute('aria-current'); }
        });
        if (anterior) anterior.disabled = actual === 1;
        if (siguiente) siguiente.disabled = actual === total;
        if (saltar) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }

      nav.addEventListener('click', function (e) {
        var boton = e.target.closest('[data-v2-op-ir]');
        if (!boton || boton.disabled) return;
        var destino = boton.getAttribute('data-v2-op-ir');
        if (destino === 'anterior') { pintar(actual - 1, true); }
        else if (destino === 'siguiente') { pintar(actual + 1, true); }
        else { pintar(parseInt(destino, 10), true); }
      });

      pintar(1, false);
    });
  }

  function eligeEdad(edad) {
    if (!edad) return;
    var caja = document.querySelector('.v2-pack--activo') || document.querySelector('[data-v2-pack-tallas]');
    if (!caja) return;
    var sels = caja.querySelectorAll('[data-v2-edad]');
    Array.prototype.forEach.call(sels, function (sel) {
      for (var i = 0; i < sel.options.length; i++) {
        var v = (sel.options[i].value || '') + ' ' + (sel.options[i].text || '');
        if (v.indexOf(edad) !== -1) {
          sel.selectedIndex = i;
          try { sel.dispatchEvent(new Event('change', { bubbles: true })); } catch (err) {}
          break;
        }
      }
    });
  }

  // Anclas internas. El salto es inmediato: un scroll animado de un segundo
  // en móvil se siente como que el botón no ha hecho nada.
  function initAnclas() {
    document.addEventListener('click', function (e) {
      var irEdad = e.target.closest ? e.target.closest('[data-v2-ir-edad]') : null;
      if (irEdad) eligeEdad(irEdad.getAttribute('data-v2-ir-edad'));

      var a = e.target.closest ? e.target.closest('a[href^="#v2-"]') : null;
      if (!a || a.hasAttribute('data-v2-add')) return;
      var destino = document.getElementById(a.getAttribute('href').slice(1));
      if (!destino) return;
      e.preventDefault();
      destino.scrollIntoView({ behavior: 'auto', block: 'start' });
    });
  }

  // Onda desde el punto exacto donde se pulsa. Confirma el clic al instante,
  // antes incluso de que el carrito responda: el visitante nunca duda de si
  // "ha entrado" o no y deja de pulsar dos veces.
  function initOnda() {
    if (reduce) return;
    document.addEventListener('pointerdown', function (e) {
      var btn = e.target.closest ? e.target.closest('.v2-btn') : null;
      if (!btn || btn.disabled) return;
      var caja = btn.getBoundingClientRect();
      btn.style.setProperty('--v2-onda-x', (e.clientX - caja.left) + 'px');
      btn.style.setProperty('--v2-onda-y', (e.clientY - caja.top) + 'px');
      btn.classList.remove('v2-btn--onda');
      void btn.offsetWidth;
      btn.classList.add('v2-btn--onda');
    }, { passive: true });
  }

  // Botones "añadir el pack X" repartidos por la página. El interceptor
  // global (en el cajón) es quien añade: aquí solo queda un respaldo por
  // si esa pieza no está en la página.
  function initAnadirDirecto() {
    document.addEventListener('click', function (e) {
      if (typeof window.__feCartDispara === 'function') return;
      var btn = e.target.closest ? e.target.closest('[data-v2-add]') : null;
      if (!btn || btn.disabled) return;

      var form = document.getElementById('v2-form');
      var compra = document.getElementById('v2-comprar');
      if (!form) {
        if (compra) compra.scrollIntoView({ behavior: 'auto', block: 'start' });
        return;
      }

      e.preventDefault();

      var cantidad = btn.getAttribute('data-v2-add');
      var radio = document.querySelector('.v2-pack__radio[value="' + cantidad + '"]');
      if (radio) {
        if (!radio.checked) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        var campoCantidad = document.getElementById('v2-cantidad');
        if (campoCantidad) campoCantidad.value = cantidad;
      }

      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(document.getElementById('v2-boton'));
      } else {
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });
  }

  // Antes / después: el asa recorta la foto de encima. Ratón, dedo y teclado.
  function initAntesDespues() {
    var escenas = document.querySelectorAll('[data-v2-ba]');
    if (!escenas.length) return;

    Array.prototype.forEach.call(escenas, function (escena) {
      var fotos = escena.querySelector('.v2-ba__fotos');
      var asa = escena.querySelector('[data-v2-ba-asa]');
      if (!fotos || !asa) return;

      var pct = 50;
      var arrastrando = false;

      function anchoFoto() {
        escena.style.setProperty('--v2-ba-ancho', fotos.clientWidth + 'px');
      }

      function pinta(n) {
        pct = Math.max(4, Math.min(96, n));
        escena.style.setProperty('--v2-ba-pct', pct + '%');
        asa.setAttribute('aria-valuenow', String(Math.round(pct)));
      }

      function desdeEvento(e) {
        var x = e.clientX;
        if (e.touches && e.touches[0]) x = e.touches[0].clientX;
        var caja = fotos.getBoundingClientRect();
        if (caja.width < 1) return;
        pinta(((x - caja.left) / caja.width) * 100);
      }

      function paraArrastre() {
        arrastrando = false;
        escena.classList.remove('v2-ba__escena--guia');
      }

      fotos.addEventListener('pointerdown', function (e) {
        arrastrando = true;
        escena.classList.remove('v2-ba__escena--guia');
        desdeEvento(e);
        if (fotos.setPointerCapture) {
          try { fotos.setPointerCapture(e.pointerId); } catch (err) {}
        }
      });
      fotos.addEventListener('pointermove', function (e) {
        if (!arrastrando) return;
        desdeEvento(e);
      });
      fotos.addEventListener('pointerup', paraArrastre);
      fotos.addEventListener('pointercancel', paraArrastre);

      asa.addEventListener('keydown', function (e) {
        var paso = e.shiftKey ? 10 : 4;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
          e.preventDefault();
          pinta(pct - paso);
        } else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
          e.preventDefault();
          pinta(pct + paso);
        } else if (e.key === 'Home') {
          e.preventDefault();
          pinta(0);
        } else if (e.key === 'End') {
          e.preventDefault();
          pinta(100);
        }
      });

      anchoFoto();
      pinta(50);
      window.addEventListener('resize', anchoFoto);
      if (!reduce) escena.classList.add('v2-ba__escena--guia');
    });
  }

  function arranca() {
    initReveal();
    initFaq();
    initComparativa();
    initOpiniones();
    initAnclas();
    initOnda();
    initAnadirDirecto();
    initAntesDespues();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arranca, { once: true });
  } else {
    arranca();
  }
})();
